export default {
  sendModalOpen: () => {
    global.dataLayer.push({
      event: "custom_event",
      event_category: "sales_show",
      event_action: "claim_your_home",
      event_label: "open"
    });
  },

  sendHomeownerInfoSubmit: () => {
    global.dataLayer.push({
      event: "custom_event",
      event_category: "sales_show",
      event_action: "claim_your_home",
      event_label: "submit_homeowner_info"
    });
  },

  sendOwnerNameSelected: ({ slot }) => {
    global.dataLayer.push({
      event: "custom_event",
      event_category: "sales_show",
      event_action: "claim_your_home",
      event_label: `verify_ownership|slot=${slot}`
    });
  },

  showModalGAEvent: () => {
    global.dataLayer.push({
      event: "custom_event",
      event_category: "sales_show",
      event_action: "claim_your_home",
      event_label: "open_contact_form"
    });
  }
};
